import { dew as _noopDew } from "../function/noop";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var _undefined = _noopDew()(); // Support ES3 engines


  exports = function (val) {
    return val !== _undefined && val !== null;
  };

  return exports;
}